import React, { useState, useRef, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import AddIcon from '@mui/icons-material/Add';
import { MixPanelTrackedLink, MuiAvatar, ShowSpinnerOrLabel, UploadImage } from "../../../components";
import { IconButton, Stack, Typography } from "@mui/material";
import { profileActions } from "../../../store/actions";
import { S3_BUCKET } from "../../../constants";

export default function () {
    const dispatch = useDispatch();
    const imageUploadRef = useRef();
    const currentUserDetails = useSelector(state => state.authentication.current_user)

    const [profileImage, setProfileImage] = useState();
    const [newImageSelected, setNewImageSelected] = useState(false);
    const [uploadButtonText, setUploadButtonText] = useState('Upload Photo')
    const [uploadImageLoading, setUploadImageLoading] = useState(false);
    const [imageDataPayload, setImageDataPayload] = useState();

    const setSelectedImage = async (event) => {
        let newImage = event.target.files[0];
        let fileReader = new FileReader();

        fileReader.onloadend = () => {
            setProfileImage(fileReader.result)
        }
        setUploadButtonText('Save');
        setNewImageSelected(true);

        fileReader.readAsDataURL(newImage);

        const imageFormData = new FormData();
        imageFormData.append(
            'profile_image',
            newImage,
            newImage.name
        );
        imageFormData.append('id', currentUserDetails.id);
        setImageDataPayload(imageFormData);
        event.target.value = null;
    }

    const removeProfileImage = async (event) => {
        const payload = {
            id: currentUserDetails.id,
            is_remove: 1
        }
        await dispatch(profileActions.updateProfileImage(payload));
        await dispatch(profileActions.fetchUserData());
    };

    const uploadImage = async () => {
        setUploadImageLoading(true);
        const uploadSuccess = await dispatch(profileActions.updateProfileImage(imageDataPayload));
        setUploadImageLoading(false);
        if (uploadSuccess)
            dispatch(profileActions.fetchUserData())
        else setProfileImage(null)

        setNewImageSelected(false);
        setUploadButtonText('Upload Photo');
    }

    useEffect(() => {
        if (currentUserDetails?.profiles?.profile_image)
            setProfileImage(S3_BUCKET + currentUserDetails.profiles.profile_image)
        else setProfileImage(null)
    }, [currentUserDetails])

    const mapImageButton = () => {
        if (profileImage && !newImageSelected)
            return <React.Fragment>
                <Typography gutterBottom sx={{ fontSize: '13px' }}>Remove your current photo to upload a new one.</Typography>
                <MixPanelTrackedLink
                    type="button"
                    label="Remove Current Photo"
                    context="Profile setting tab"
                    variant="outlined"
                    color="error"
                    onClick={removeProfileImage}
                >
                    Remove Current Photo
                </MixPanelTrackedLink>
            </React.Fragment>
        return <MixPanelTrackedLink
            type="button"
            label={uploadButtonText}
            context="Profile setting tab image uploading"
            variant="outlined"
            onClick={() => { newImageSelected ? uploadImage() : imageUploadRef.current.click() }}>
            <ShowSpinnerOrLabel label={uploadButtonText} loading={uploadImageLoading} />
        </MixPanelTrackedLink>
    }

    return <Stack className="ProfilePic" direction="row" spacing={2}>
        <MuiAvatar src={profileImage} variant="square">
            <IconButton onClick={() => imageUploadRef.current.click()}>
                <AddIcon />
            </IconButton>
        </MuiAvatar>
        <Stack>
            <Typography gutterBottom sx={{fontSize: '18px'}}>Profile Photo</Typography>
            {mapImageButton()}
        </Stack>
        <UploadImage handleUpload={setSelectedImage} ref={imageUploadRef} />
    </Stack>
}